import { AuthorizationRecord } from '../../auth/types/authorization-record.type';
import { AppRoute } from '../../routing/appRoutes';

export const useAppFeatureWhiteList = (appRoutes: AppRoute[], allowedFeatures: AuthorizationRecord | null) => {
  const whiteListedAppRoutes = appRoutes.filter((route) => {
    if (allowedFeatures) {
      return Object.keys(allowedFeatures).includes(route.name);
    }
    return false;
  });

  return {
    whiteListedAppRoutes,
  };
};
